import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DatabindingService } from '../../../../Services/Databinding/databinding.service';

// example of usage
// <app-data-binding-base-form
//   (updateLoadingE)="updateLoading($event)"
//   [document]="document"
//   [recordType]="pushbackType"
//   [isNeedShowForm]="isNeedShowForm"
//   [isUserOwnerOfDocument]="isUserOwnerOfDocument"
//   [sfObjectsSuggestionList]="sfObjectsSuggestionList"
// >
// </app-data-binding-base-form>

@Component({
  selector: 'app-data-binding-base-form',
  templateUrl: './data-binding-base-form.component.html',
  styleUrls: ['./data-binding-base-form.component.sass']
})
export class DataBindingBaseFormComponent implements OnInit {
  @Output() public updateLoadingE: EventEmitter<any> = new EventEmitter();
  @Input() document: any; // Object
  @Input() isNeedShowForm: boolean = true;
  @Input() isUserOwnerOfDocument: boolean = true;
  @Input() sfObjectsSuggestionList: string[] = [];
  @Input() recordType: any = { name: '' };

  type_placeholder = 'SALESFORCE_RECORD_TYPE';
  sfCurrObjMetaList = [];

  constructor(public databindingService: DatabindingService) {}

  updateLoadingHandler(state, msg) {
    this.updateLoadingE.emit({ state, msg });
  }

  ngOnInit() {
    if (this.isUserOwnerOfDocument) {
      this.getSfObjectMeta(this.recordType.name);
    }
  }

  getSfObjectMeta(objectTypeStr) {
    this.databindingService.getSalesforceObjectMetadata(objectTypeStr).subscribe(
      (meta) => {
        this.sfCurrObjMetaList = meta || [];
      },
      () => {
        this.updateLoadingHandler(false, '');
      }
    );
  }

  onChangeSfObjectType(objectTypeStr) {
    const metaSelects = Array.from(document.querySelectorAll('.meta-select'));
    const metaCheckboxes = Array.from(document.querySelectorAll('.slds-checkbox'));

    // clear inputs values
    metaSelects.forEach((selectItem: HTMLSelectElement) => {
      selectItem.value = '';
    });
    // unchecked checkboxes
    metaCheckboxes.forEach((checkboxItem: HTMLInputElement) => {
      checkboxItem.checked = false;
    });

    this.document.fields.forEach((itm) => {
      itm.integrations[0].field = '';
      itm.isAppendSfFieldIntoSnField = false;
      itm.isUpdateSfFieldFromDocument = false;
    });

    this.getSfObjectMeta(objectTypeStr);
  }

  onSfFieldChange(pushBackDocField) {
    const fieldValue = pushBackDocField.integrations[0].field;

    if (fieldValue) {
      // remove this part "pushBackDocField.type === 'text'" when prefill for different types will be ready
      if (
        pushBackDocField.isUpdateSfFieldFromDocument === false &&
        this.databindingService.isAllowedTypeOfDocumentField(pushBackDocField.type)
      ) {
        pushBackDocField.isAppendSfFieldIntoSnField = true;
      }
    } else {
      pushBackDocField.isAppendSfFieldIntoSnField = false;
      pushBackDocField.isUpdateSfFieldFromDocument = false;
    }
  }

  isFieldNotAvailabelForUpdate(sfObjectField) {
    const isNotAvailable = this.databindingService.isFieldNotAvailabelForUpdate(
      sfObjectField.integrations[0].field,
      this.sfCurrObjMetaList
    );

    if (isNotAvailable) {
      sfObjectField.isUpdateSfFieldFromDocument = false;
    }

    return isNotAvailable;
  }
}
